export default __webpack_public_path__ + "images/SW.e7cd29f.png";